import { loadableReady } from '@loadable/component';
import { forEach } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import Notifications from '../../common/utils/Notifications';
import App from '../../core/App';
import audioPolyfill from './audioPolyfill';
import createApolloClient from './createApolloClient';
import history from './browserHistory';
import '../../../assets/css/icons/icomoon/styles.css';
import '../../../assets/css/icons/program-group-types/style.css';
import '../../../assets/css/icons/fontawesome/styles.min.css';
import '../../../assets/css/bootstrap.css';
import '../../../assets/css/core.css';
import '../../../assets/css/components.css';
import '../../../assets/css/colors.css';
import '../../../assets/css/jstree.css';
// import 'sweetalert2/dist/sweetalert2.min.css';
import '../../../assets/css/custom.css';
import '../../../assets/css/components/strike.css';
import '../../../assets/css/components/emoji-mart.css';
import '../../../assets/css/components/video-react.css';
import '../../../assets/css/icons/ed-icon.css';
import '../../../assets/css/icons/ed-icons/style.css';
import { getLanguage } from '../../common/components/utils/Translations/helpers/makeTranslationHelpers';
import RootTranslationProvider from './RootTranslationProvider';
audioPolyfill();
function registerServiceWorker() {
    if (!window.App.enableServiceWorker || !('serviceWorker' in navigator)) {
        return;
    }
    navigator.serviceWorker.getRegistrations().then(registrations => forEach(registrations, (registration) => {
        var _a;
        if ((_a = registration === null || registration === void 0 ? void 0 : registration.active) === null || _a === void 0 ? void 0 : _a.scriptURL.match(/sw.js/)) {
            registration.unregister();
        }
    }));
    import('workbox-window').then(async ({ Workbox }) => {
        const wb = new Workbox('/service-worker.js');
        wb.addEventListener('controlling', () => Notifications.systemNonReactWarning('System warning', 'This page has been updated. Reload the page to see actual version'));
        const registration = await wb.register();
        registration && history.listen(() => registration.update());
    });
}
async function startApp() {
    const response = await fetch(window.App.edanaTranslationSchemaUrl, {
        cache: 'no-store',
    });
    const translations = await response.json();
    const language = getLanguage(window.App.preferences);
    const container = document.getElementById('app');
    const storeProvider = { store: null };
    const apolloClient = createApolloClient({
        apiUrl: window.App.apiUrl,
        initialState: window.App.apolloState,
        storeProvider,
    });
    const mountApp = window.App.shouldHydrate
        ? ReactDOM.hydrate
        : ReactDOM.render;
    mountApp(<Router history={history}>
      <RootTranslationProvider language={language} translations={translations}>
        <App apolloClient={apolloClient} appConfig={window.App}/>
      </RootTranslationProvider>
    </Router>, container);
}
registerServiceWorker();
if (window.App.shouldHydrate) {
    loadableReady(startApp);
}
else {
    startApp();
}
